import {
  React,
  // Fragment,
  useContext,
  // useState,
  // useEffect,
  // Fragment,
} from "react";
import Banner from "./Banner";
import Announcement from "./Announcement";
import CurrencyTable from "./CurrencyTable";
import ThemeContext from "../../../context/themeContext";
import StepsToByCrypto from "./StepsToByCrypto";
import Features from "./Features";
import CryptoToday from "./CryptoToday";
import LogoLine from "./LogoLine";
import Faq from "./Faq";
import Page from "../../../components/Page";
// import Social from "./Social";
import TaralProducts from "./TaralProducts";
import Resources from "./Resources";
// import PopupModal from "../../../components/modals/PopupModal";
// import { AuthContext } from "../../../context/auth";
// import { AnimationOnScroll } from "react-animation-on-scroll";
// import Slider from "./Slider";

export default function Home() {
  const themeSettings = useContext(ThemeContext);
  // const [isAnimationVisible, setIsAnimationVisible] = useState(false);
  // const { userLoggedIn } = useContext(AuthContext);
  // const [poPup, setPoPup] = useState(false);

  // useEffect(() => {
  //   setPoPup(true);
  // }, []);
  // useEffect(() => {
  //   setIsAnimationVisible(true);
  //   return () => {
  //     setIsAnimationVisible(false);
  //   };
  // }, []);

  return (
    <Page title="Tarality: Buy BTC on easy EMIs">
      {/* {poPup && !userLoggedIn && (
        <PopupModal open={poPup} close={() => setPoPup(false)} />
      )} */}
      {/* {isAnimationVisible && ( */}
      {/* <Fragment> */}
      <Banner />
      <Announcement />
      <CurrencyTable />

      {/* <AnimationOnScroll animateIn="animate__fadeInUp"> */}
      <TaralProducts themeSettings={themeSettings} />
      {/* </AnimationOnScroll> */}
      <Features />
      {/* <AnimationOnScroll animateIn="animate__fadeInUp"> */}
      <StepsToByCrypto />
      {/* </AnimationOnScroll> */}
      {/* <AnimationOnScroll animateIn="animate__fadeInUp"> */}
      {/* <Social /> */}
      <Resources />
      {/* </AnimationOnScroll> */}

      {/* <Slider /> */}
      <CryptoToday themeSettings={themeSettings} />
      <LogoLine />
      <Faq />
      {/* </Fragment> */}
      {/* )} */}
    </Page>
  );
}
